import '@/assets/styles/reset.css';
import '@/assets/styles/anim/index.css';
import '@/assets/styles/theme-project.css';
import 'virtual:svg-icons-register';
import { createPersistedState } from 'pinia-plugin-persistedstate';
import router from './router';
import App from './App.vue';

import { pluginsConfig as plugins, directive } from '@/layouts/sfapp';
import initSettingsPlugin from '@/plugins/settings';

const render = async () => {
  await plugins.onInit([initSettingsPlugin]);

  const app = createApp(App);
  const pinia = createPinia();
  pinia.use(
    createPersistedState({
      key: (id) => `pinia_${id}`,
    }),
  );
  app.use(pinia);
  app.use(router);
  app.use(directive);
  await plugins.onVuePluginRegister({ router, app, pinia });
  app.mount('#main');
};

(window as any).__POWERED_BY_SFVINE__ = true

console.warn = () => {};

render().catch((err) => {
  console.error(err);
});
